import { signal } from '@preact/signals';
import { createContext } from 'preact';

import type { HubId } from './navigation.js';

// Waar staat een pagina in (WP2)? De PageHeader van de app (lib/ui.tsx) leest dit en past zich aan:
// - in een hub (samengevoegde pagina, lib/hub.tsx): de titel van de hub en de tabbladen eronder;
// - als sectie in een hub (Sterren = Goedkeuren + Beloningen): een sectiekop (h2) in plaats van h1;
// - in een blad (lib/routeSheet.tsx): de titel gaat naar de kop van het blad, de knoppen blijven.
// Zo hoeven de schermen zelf niets te weten van de navigatie.

export interface HubFrame {
  /** Leeg bij een sectie buiten een hub (Klusjes in Taken). */
  id?: HubId | undefined;
  mode: 'page' | 'section';
}

export const HubContext = createContext<HubFrame | null>(null);

export interface SheetFrame {
  /** De PageHeader in het blad geeft zijn titel door aan de kop van het blad. */
  setTitle: (title: string) => void;
}

export const SheetPageContext = createContext<SheetFrame | null>(null);

/** Terug naar de ouderpagina; op de telefoon staat de pijl in de bovenbalk (components/Shell.tsx). */
export interface TopBack {
  href?: string | undefined;
  onPress?: (() => void) | undefined;
  label: string;
  /** Van wie is hij (zodat een oude pagina hem bij het weggaan niet van een nieuwe weghaalt). */
  owner: object;
}

export const topBack = signal<TopBack | null>(null);
